import { TranslateService } from '@ngx-translate/core';

// Base translations (always present)
import baseEn from 'src/assets/i18n/en.json';
import baseAr from 'src/assets/i18n/ar.json';


export function applyTenantTranslations(translate: TranslateService, tenantId: string) {
     
 // Seed base translations synchronously (no HTTP)
 translate.setTranslation('en', baseEn as Record<string, any>, false);
 translate.setTranslation('ar',baseAr as Record<string, any>, false);

 import(`src/assets/i18n/${tenantId}/${tenantId}-en.json`).then(tenantEn=>{
    if (tenantEn) {
        translate.setTranslation('en', tenantEn as Record<string, any>, true);
      }
});
import(`src/assets/i18n/${tenantId}/${tenantId}-ar.json`).then(tenantAr=>{
    if (tenantAr) {
        translate.setTranslation('ar', tenantAr as Record<string, any>, true);
      }
});
}


